import { ApiClient, ClientType } from './apiClient/ApiClient';
import { ServiceType } from './apiClient/config';

const apiClient = () => { return ApiClient.Client(ClientType.NotCached, ServiceType.Apiv2); };

export const getEntities = async () => await apiClient().get<any>(`/entities`);

export const deleteEntity = async (entityId: any) => await apiClient().delete(`/entities/general-entities/${entityId}`);